<template>
  <b-tab class="border-0">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('setting.list.product.type') }}</span>
    </template>

    <McEditableTable
      v-show="isTableDataAvailable"
      ref="table"
      searchable
      hasEmit:submitError
      :fields="fields"
      :apiClient="apiClient"
      :apiErrorMappings="productTypeApiErrorMappings"
      @available-change="handleDataAvailable"
      @submitError="handleSubmitError"
    >
      <template #[`cell(product_category.min_temperature)`]="{ item }">
        {{ item?.product_category?.min_temperature ?? '-' }}
      </template>
      <template #[`cell(product_category.max_temperature)`]="{ item }">
        {{ item?.product_category?.max_temperature ?? '-' }}
      </template>
      <template #[`cell(product_category.box_types)`]="{ item }">
        <McChipList
          v-if="item?.product_category?.box_types && item?.product_category?.box_types?.length"
          :items="item.product_category.box_types"
          :max-visible="3"
          itemTextField="name"
          showAllMode="dropdown"
          :showAllDropdownTitle="$t('setting.list.product.field.boxType')"
          showAllDropdownTrigger="action"
        />
        <span v-else>-</span>
      </template>
    </McEditableTable>
    <div v-show="!isTableDataAvailable" class="empty-table-container">
      <img :src="illustrationPath" alt />
      <strong>{{ $t('setting.list.product.emptyType') }}</strong>
      <p>{{ $t('setting.list.product.add') }}</p>
      <b-button variant="primary" @click="handleAdd">
        <i class="mc-fa icon-outline_plus"></i> {{ $t('global.addField') }}
      </b-button>
    </div>
  </b-tab>
</template>

<script>
import { mapGetters } from 'vuex'

import McEditableTable from '@/components/McEditableTable'
import McChipList from '@/components/McChipList'

import productTypeFields from './lib/fields/productTypeFields'
import productTypeApiErrorMappings from './lib/constants/product-type-api-error-mappings'

import * as ProductType from '@/services/rest-api/lib/product/product-type'

export default {
  components: {
    McEditableTable,
    McChipList,
  },
  data() {
    return {
      isTableDataAvailable: true,
      productTypeApiErrorMappings: productTypeApiErrorMappings,
    }
  },
  computed: {
    fields() {
      return productTypeFields
    },
    apiClient() {
      return {
        get: ProductType.get,
        store: ProductType.store,
        show: ProductType.show,
        update: ProductType.update,
        delete: ProductType.deleteSingle,
      }
    },
    ...mapGetters({
      isWhitelabel: 'identity/isWhitelabel',
      isMetrack: 'identity/isMetrack',
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    illustrationPath() {
      if (this.isWhitelabel() || this.isMetrack()) {
        return require(`@/assets/images/illustration/whitelabel/no-data.svg`)
      }
      return require(`@/assets/images/illustration/saas/no-data.svg`)
    },
  },
  methods: {
    handleDataAvailable(isAvailable) {
      this.isTableDataAvailable = isAvailable
    },
    handleAdd() {
      this.$refs.table.handleAdd()
    },
    handleSubmitError(data) {
      if (data.errors && data.status == 400) {
        if (data.errors.name && data.errors.name[0] == 'value is not unique') {
          this.$mcToast.error('Gagal simpan. Jenis Produk sudah terdaftar di sistem.')
          return
        }

        this.$mcToast.error('Terdapat kesalahan format pada input anda')
      }
    },
  },
}
</script>
